import React from 'react';
import './Event_about.css';
import close from '../../img/close.svg'

const FAQ = (props) => {
    const state = {
        About_item: [
            {
                text: `Level up Your DevOps with GitHub Actions and Kubernetes`,
            },
            {
                text: `How to build a secure DevOps pipeline`,
            },
            {
                text: `Learn how to identify Cloud Risks and Threats in Real-Time with Stream Detection`,
            },
            {
                text: `Mild GitOps introductions - your Devs won’t go nuts`,
            },
            {
                text: `Tips on how to automate production deployments with GitOps`,
            },
            {
                text: `CI/CD best practices for building modern applications`,
            },
            {
                text: `Comprehensive guide on how to Build Stateful Workloads in Kubernetes`,
            },
            {
                text: `Micro-services and Multi Cluster Managed Kafka`,
            },
            {
                text: `Cognitive Continuous Testing in modern DevOps`,
            },
            {
                text: `Observability and monitoring, hand in hand approach`,
            },
        ],
    };

    const renderAboutItem = (item, i) => {
        return (
            <div className='about_item'>
                <p>
                    <span className='terminal_tag_name'>        <span class='about_terminal-java_text-yellow'>println</span></span>
                    <span className='terminal_bracket'>(</span>
                    "
                    <span className='terminal_text'>{item.text}</span>
                    "
                    <span className='terminal_bracket'>)</span>
                </p>
            </div>
        );
    };

    return (
        <div className="about_wrap">
            <div className="about container">
                <h2 className="about_title">What event is about</h2>
                <div className="about_blocks">
                    <div className='about_terminal--header'>
                        <div className='about_terminal--tab'>
                            <p className='about_terminal--title'>audience.groovy</p>
                            <img className='about_terminal--img' src={close} alt="" />
                        </div>
                        <div className='about_terminal--tab about_terminal--tab_active'>
                            <p className='about_terminal--title'>event_about.groovy</p>
                            <img className='about_terminal--img' src={close} alt="" />
                        </div>
                    </div>
                    <div className='about_terminal--body'>
                        <div class='about_terminal-java_head'>
                            <p>class <span class='about_terminal-java_text-green'>EventAbout</span> &#123;</p>
                            <p>     <span class='about_terminal-java_text-green'>def</span> <span class='about_terminal-java_text-yellow'>topics</span>() &#123;</p>
                        </div>
                        {state.About_item.map((item, i) => renderAboutItem(item, i))}
                        <div class='about_terminal-java_footer'>
                            <p>    &#125;</p>
                            <p>&#125;</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;